.pdpReviewsWrapper {
  background-color: var(--colors-background);
  max-width: 1497px;
  padding: 24px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.pdpReviewsCount {
  margin-bottom: 16px;
}

.pdpReviewsSortSelectorContainer {
  display: flex;
  width: 100%;
  gap: 12px;
  margin-bottom: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pdpReviewsActivitiesDividerMobile {
  background-color: var(--colors-grays-light);
  height: 1px;
  border: none;
  margin: 24px -24px;
}

.loading {
  position: relative;
  margin-top: 8px;
  bottom: 0px;
  left: 0;
  right: 0;
}

@media all and (--reefer-media-tablet-min) {
  .pdpReviewsWrapper {
    padding: 0;
  }

  .pdpReviewsCount {
    margin-bottom: 0;
  }

  .pdpReviewsSortSelectorContainer {
    flex-direction: row;
    justify-content: space-between;
  }

  .pdpReviewsActivitiesDividerMobile {
    display: none;
  }
}
